import React, { useState } from "react";
import { Tabs, Button, Table, Form, Input, Modal, message, Card } from "antd";
import { PlusCircleOutlined } from "@ant-design/icons";
import Country from "../country/Country";
import State from "../state/State";
import City from "../city/City";
import Pincode from "../pincode/Pincode";
import Language from "../language/Language";
import FamilyMemberType from "../familyMemeberType/FamilyMemeberType";
import HealthCondition from "../healthCondition/HealthCondition";
import TAT from "../tat/TAT";
import TestRequirements from "../testRequirements/TestRequirements";
import Containers from "../containers/Containers";
import Lab from "../lab/Lab";
import Test from "../test/Test";
import Pouch from "../pouch/Pouch";
import Package from "../package/Package";
import TestCategory from "../testCategory/TestCategory";
import TestTags from "../testTags/TestTags";
import Coupons from "../coupons/Coupons";
import WorkingHours from "../workinghours/WorkingHours";
import AppDownloads from "../appdownloads/AppDownloads";
import DelayTime from "../delaytime/DelayTime";
import Parameter from "../parameter/Parameter";
import TestParameter from "../testparameters/TestParameter";
import TestDepartment from "../testDepartment/TestDepartment";
import SystemSettings from "../systemSettings/SystemSettings";

const { TabPane } = Tabs;

const MasterData = () => {
  const [mode] = useState("top");
  const [tabs] = useState([
    { key: "1",  label: "Country",            content: <Country /> },
    { key: "2",  label: "State",              content: <State /> },
    { key: "3",  label: "City",               content: <City /> },
    { key: "4",  label: "Pincode",            content: <Pincode /> },
    { key: "5",  label: "Language",           content: <Language /> },
    { key: "6",  label: "Family Member Type", content: <FamilyMemberType /> },
    { key: "7",  label: "Health Condition",   content: <HealthCondition /> },
    { key: "8",  label: "TAT(Turn Around Time)", content: <TAT /> },
    { key: "9",  label: "Test Requirements",  content: <TestRequirements /> },
    { key: "10", label: "Containers",         content: <Containers /> },
    { key: "11", label: "Pouch",              content: <Pouch /> },
    { key: "12", label: "Test Category",      content: <TestCategory /> },
    { key: "13", label: "Test Department",    content: <TestDepartment /> },
    { key: "14", label: "Test Tags",          content: <TestTags /> },
    { key: "15", label: "Test",               content: <Test /> },
    { key: "16", label: "Package",            content: <Package /> },
    { key: "17", label: "Parameter",          content: <Parameter /> },
    { key: "18", label: "Test-Parameter",     content: <TestParameter /> },
    { key: "19", label: "Coupons",            content: <Coupons /> },
    { key: "20", label: "Working Hours",      content: <WorkingHours /> },
    { key: "21", label: "Delay Time",         content: <DelayTime /> },
    { key: "22", label: "App Downloads",      content: <AppDownloads /> },
    { key: "23", label: "System Settings",    content: <SystemSettings /> },
  ]);

  return (
    <div style={{ overflowX: "hidden", width: "100%" }}>
      <Tabs
        defaultActiveKey="1"
        tabPosition={mode}
        style={{ maxWidth: "100%" }}
        type="card"
        // Enables horizontal scroll on the tab bar for mobile
        tabBarStyle={{
          overflowX: "auto",
          flexWrap: "nowrap",
          marginBottom: 0,
        }}
      >
        {tabs.map((tab) => (
          <TabPane tab={tab.label} key={tab.key}>
            {tab.content}
          </TabPane>
        ))}
      </Tabs>

      <style>{`
        /* Tab bar scrollable on mobile */
        @media (max-width: 768px) {
          .ant-tabs-nav-wrap {
            overflow-x: auto !important;
            -webkit-overflow-scrolling: touch;
          }
          .ant-tabs-nav-list {
            flex-wrap: nowrap !important;
          }
          .ant-tabs-tab {
            white-space: nowrap;
            font-size: 12px !important;
            padding: 4px 8px !important;
          }
          .ant-tabs-content-holder {
            overflow-x: hidden;
          }
        }
      `}</style>
    </div>
  );
};

export default MasterData;